import { gql } from '@apollo/client';

const Fragments = {
  documentSyncState: gql`
    fragment documentSyncState on DocumentSyncState {
      documentSyncStateId
      documentSyncTypeId
      sourceDocumentTypeCode
      sourceStateCode
      destinationDocumentTypeCode
      destinationFinalStateCode
      destinationInitialStateCode
    }
  `,
  documentStateXType: gql`
    fragment documentStateXType on DocumentStateXType {
      documentStateId
      documentStateCode
      documentStateName
      documentTypeId
      documentTypeCode
      documentTypeName
      isExternal
    }
  `,
  dictionarySyncType: gql`
    fragment dictionarySyncType on DictionarySyncType {
      dictionaryItemId
      dictionaryItemCode
      dictionaryItemName
    }
  `
};

export default Fragments;
